export const LOGO_URL = "https://customer-assets.emergentagent.com/job_wanderer-network/artifacts/w8loc1if_IMG_20260409_162234_176.webp";
export const BRAND_NAME = "50 States Sober";
export const BRAND_TAGLINE = "Ask me how";
